module.exports = __webpack_public_path__ + "img/jambyl1.220b3d9e.jpg";